import React from "react";

const OrangeCheck = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17.5"
    height="13.41"
    viewBox="0 0 17.5 13.41">
    <path
      fill="#fa461d"
      d="M21 7L9 19l-5.5-5.5 1.41-1.41L9 16.17 19.59 5.59z"
      transform="translate(-3.5 -5.59)"
    />
  </svg>
);

export default OrangeCheck;
